export default __webpack_public_path__ + "static/media/services_devops.e8178899.svg";